import { render } from "./LeadDialogHeader.vue?vue&type=template&id=1cce40b0"
import script from "./LeadDialogHeader.vue?vue&type=script&lang=js"
export * from "./LeadDialogHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__